import DashboardContent from 'components/lab/atoms/DashboardContent'
import { EraExceptionQueue } from 'components/lab/billingEraReports/EraExceptionQueue'
import routes from 'components/lab/constants/routes'
import React from 'react'

export const EraExceptionQueuePage = () => {
  return (
    <div>
      <DashboardContent
        title={'ERA Exceptions'}
        icon="fa fa-triangle-exclamation"
        content={
          <div>
            <div className="card card-primary mt-1 p-2">
              <EraExceptionQueue />
            </div>
          </div>
        }
        breadcrumb={[
          {
            label: 'Billing ERA Files',
            to: `${routes.index}${routes.billing.root}${routes.billing.eraFiles}`,
          },
        ]}
      />
    </div>
  )
}
